import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { getMessaging, onMessage } from "firebase/messaging";
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from './notification.service';
@Injectable()
export class MessagingService {
    currentMessage = new BehaviorSubject(null);

    constructor(private angularFireMessaging: AngularFireMessaging, private notificationService: NotificationService, private toaster: ToastrService,) { }

    requestPermission() {
        this.angularFireMessaging.requestToken.subscribe(
            (token) => {
                let userData = JSON.parse(localStorage.getItem('user'));
                let key = {
                    userId: userData.UserId,
                    deviceToken: token
                }
                this.notificationService.addUserDeviceToken(key).subscribe((res) => {
                },
                    ({ error }) => {
                        this.toaster.error("Cannot Add Device", "Error");
                    })
            },
            (err) => {
                console.error('Unable to get permission to notify.', err);
            });
    }

    getToken(){
        this.angularFireMessaging.getToken.subscribe((token)=>{
            var userData = JSON.parse(localStorage.getItem('user'));
            var key = {
             userId: userData.UserId,
             deviceToken: token
            }
            this.notificationService.addUserDeviceToken(key).subscribe((res)=>{
         
            });
        });
    }

    receiveMessage() {
        this.angularFireMessaging.messages.subscribe((res) => {
            this.currentMessage.next(res);
        });
    }


}